import React, { useEffect, useRef, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './ClientSection.css';

// --- BULK IMPORTS ---
import cit from '../../../assets/Clients/cit.png';
import velnexus from '../../../assets/Clients/velnexus.png';
import velammalvidyalaya from '../../../assets/Clients/velammalvidyalaya.png';
import imgMgr from '../../../assets/Clients/MgrUnivsty.png';
import snm from '../../../assets/Clients/snm.png';
import FestonSolor from '../../../assets/Clients/FestonSolor.png';
import Feston from '../../../assets/Clients/Feston.png';
import Deye from '../../../assets/Clients/Deye.png';
import semicon from '../../../assets/Clients/semicon.png';
import Fesren from '../../../assets/Clients/Fesren.png';
import plugzmart from '../../../assets/Clients/plugzmart.png';
import caninecrown from '../../../assets/Clients/caninecrown.png';
import ATSS from '../../../assets/Clients/ATSS.png';
import janta from '../../../assets/Clients/janta.png';
import NVK from '../../../assets/Clients/NVK.png';
import JKB from '../../../assets/Clients/JKB.png';
import KCee from '../../../assets/Clients/KCee.png';
import Aulpha from '../../../assets/Clients/Aulpha.png';
import Pramatt from '../../../assets/Clients/Pramatt.png';
import windplus from '../../../assets/Clients/windplus.png';
import vinyas from '../../../assets/Clients/vinyas.png';
import horizon from '../../../assets/Clients/horizon.png';
import PrimeAuto from '../../../assets/Clients/PrimeAuto.png';
import Traverse from '../../../assets/Clients/Traverse.png';
import NilamFresh from '../../../assets/Clients/NilamFresh.png';
import smile from '../../../assets/Clients/smile.png';
import zique from '../../../assets/Clients/zique.png';
import upperroom from '../../../assets/Clients/upperroom.png';
import flipperclip from '../../../assets/Clients/flipperclip.png';
import bestforpets from '../../../assets/Clients/bestforpets.png';
import walt from '../../../assets/Clients/walt.png';
import sife from '../../../assets/Clients/sife.png';
import cata from '../../../assets/Clients/cata.png';
import manasa from '../../../assets/Clients/manasa.png';
import malathy from '../../../assets/Clients/mycons.png';
import greenFuturz from '../../../assets/Clients/greenFuturz.png';
import amalam from '../../../assets/Clients/amalam.png';
import Aiwo from '../../../assets/Clients/Aiwo.png';
import Dazbog from '../../../assets/Clients/Dazbog.png';
import DynamicStamping from '../../../assets/Clients/DynamicStamping.png';
import Ganga from '../../../assets/Clients/Ganga.png';
import SriHousing from '../../../assets/Clients/SriHousing.png';
import imgkidzee from '../../../assets/Clients/Kidzee.png';
import imglittle from '../../../assets/Clients/LittleMillennium.png';
import imgprime from '../../../assets/Clients/PrimeRehab.png';
import swathy from '../../../assets/Clients/Swathy.webp';
import nura from '../../../assets/Clients/Nura.webp';
import Tag from '../../../assets/Clients/Tag.webp';



// --- COUNTER HOOK ---
const useCounter = (end, duration = 2000, startAnimation) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!startAnimation) return;

    let startTime = null;
    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      setCount(Math.floor(progress * end));

      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
  }, [end, duration, startAnimation]);

  return count;
};

const ClientSection = () => {
  const revealRefs = useRef([]);
  revealRefs.current = [];
  const [statsVisible, setStatsVisible] = useState(false);
  const statsRef = useRef(null);

  // Helper to add elements to ref array
  const addToRefs = (el) => {
    if (el && !revealRefs.current.includes(el)) {
      revealRefs.current.push(el);
    }
  };

  const clientLogos = [
    cit, velnexus, velammalvidyalaya, imgMgr, snm, imgkidzee, imglittle, Ganga, NVK, Aiwo, imgprime, FestonSolor, Feston, Deye, semicon, Fesren,
    windplus, Dazbog, plugzmart, nura, JKB, KCee, SriHousing, swathy, malathy, caninecrown, bestforpets, PrimeAuto, janta, ATSS, Aulpha, Pramatt, cata,
    vinyas, flipperclip, sife, horizon, manasa, DynamicStamping, NilamFresh, amalam, smile, upperroom,
    walt, greenFuturz, zique, Traverse, Tag
  ];

  // --- 1. Observer for Logo Cards ---
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -50px 0px' }
    );

    revealRefs.current.forEach((el) => observer.observe(el));

    // --- 2. Observer for Stats Section ---
    const statsObserver = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setStatsVisible(true);
        }
      }, { threshold: 0.5 }
    );

    if (statsRef.current) statsObserver.observe(statsRef.current);

    return () => {
      observer.disconnect();
      statsObserver.disconnect();
    }
  }, []);

  // Use Custom Hook for Counting Animation
  const teamCount = useCounter(15, 1000, statsVisible);
  const customerCount = useCounter(1000, 1000, statsVisible);
  const projectCount = useCounter(5, 1000, statsVisible); // Counts to 2, we append 'K' manually

  return (
    <section className="client-section">
      <Container>

        {/* Header Text */}
        <div className="section-header text-center" ref={addToRefs}>
          <h2 className="section-title1">Brands We’ve Worked With</h2>
          <p className="section-subtitle1 mx-auto">
            We partner with brands to create meaningful consistent, and impactful brand experiences.
          </p>
        </div>

        {/* Logo Grid */}
        <Row className="justify-content-center">
          {clientLogos.map((logo, index) => (
            <Col
              key={index}
              xl={2} lg={2} md={3} sm={4} xs={6}
              className="mb-4"
            >
              <div
                className="client-card"
                ref={addToRefs}
                style={{ transitionDelay: `${(index % 6) * 100}ms` }}
              >
                <img src={logo} alt={`Client ${index + 1}`} className="client-logo" />
              </div>
            </Col>
          ))}
        </Row>

        {/* --- STATS SECTION --- */}
        <div className="stats-wrapper" ref={statsRef}>
          <Row className="justify-content-center align-items-center text-center text-md-start">

            {/* Stat 1 */}
            <Col xs={4} md={4} className="stat-col mb-md-0">
              <div className="stat-box">
                <span className="stat-number">{teamCount}+</span>
                <div className="stat-label">
                  Team <br /> members
                </div>
              </div>
            </Col>

            {/* Stat 2 */}
            <Col xs={4} md={4} className="stat-col mb-md-0">
              <div className="stat-box">
                <span className="stat-number">{customerCount}+</span>
                <div className="stat-label">
                  Happy <br /> customers
                </div>
              </div>
            </Col>

            {/* Stat 3 */}
            <Col xs={4} md={4} className="stat-col">
              <div className="stat-box">
                <span className="stat-number">{projectCount}K</span>
                <div className="stat-label">
                  Projects <br /> completed
                </div>
              </div>
            </Col>

          </Row>
        </div>

      </Container>
    </section>
  );
};

export default ClientSection;